import React, { useState, useRef, useCallback } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Grid,
  Paper,
  useTheme,
  Divider,
  Button,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  useMediaQuery,
  IconButton
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import AddIcon from '@mui/icons-material/Add';
import AiBotsChat from 'app/components/AiBots/AiBotsChat';
import CustomScrollbar from 'app/components/AiBots/CustomScrollbar';
import StrategyPlaceholder from 'app/components/AiBots/StrategyPlaceholder';
import StrategyDetailContent from 'app/components/Bots/Strategy/StrategyDetailContent';
import { UserBot } from 'app/components/Bots/StrategyBuilder/types';
import { createEmptyOptionBuilder } from 'app/components/Builder/OptionsStrategy/Utils/utils';
import { OptionStrategyFields } from 'app/components/Builder/OptionsStrategy/FieldsData';
import { Helmet } from 'react-helmet-async';
import PageHeader from 'app/design/speedBot/PageHeader';
import MuiChip from 'app/design/uiComponents/MuiChip';
import usePostUserBotsIsExist from 'services/Bots/usePostUserBotsIsExist';
import useSaveUserBot from 'services/Bots/useSaveUserBot';
import { PAGES } from 'app/components/Common/Breadcrumb/types';
import { useBreadcrumbManager } from 'app/components/Common/Breadcrumb';
import { FEATURES } from 'types/Feature';
import { useIsFeatureFlag } from 'app/components/Common/FeatureFlag';
import MuiButton from 'app/design/uiComponents/MuiButton';
import { YouTube } from '@mui/icons-material';
import { useGetMediaQueryUp } from 'app/hooks/useGetMediaQuery';
import useGetSiteInfo from 'services/common/useGetSiteInfo';
import IframeDialog from 'app/components/Common/IframeDialog';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CustomTooltip from 'app/design/uiComponents/CustomTooltip';

const AiBotsPage: React.FC = () => {

      // Create sample UserBot data for demonstration
      const sampleUserBot: UserBot = {
          "name": "bot101",
          "strategy_id": 28536,
          "exchange": "NSE",
          "result_ready": false,
          "is_own_bot": true,
          "is_editable": false,
          "sb_strategy": {
            "chart": "",
            "direction": "",
            "long_entry": {
              "condition_key": "",
              "conditions": []
            },
            "short_entry": {
              "condition_key": "",
              "conditions": []
            },
            "long_exit": {
              "condition_key": "",
              "conditions": []
            },
            "short_exit": {
              "condition_key": "",
              "conditions": []
            },
            "risk_type": "",
            "order_sizing": {
              "type": "",
              "value": 0
            },
            "risk_percentage": 0,
            "order_type": "",
            "order_valid_till": "",
            "square_off_time": "",
            "target_per": 0,
            "stop_loss_per": 0,
            "trailing_sl_enabled": false,
            "trailling_sl": 0,
            "trailing_sl_type": "none",
            "trailing_sl_trigger_value": 1,
            "trailing_sl_value": 1,
            "trading_start_time": "",
            "trading_stop_time": "",
            "holding_type": "mis",
            "universe": [
              {
                "name": "S1",
                "segment": "NSE",
                "symbol": "NIFTY_SPACE_50"
              }
            ],
            "resolution": "00:01:00",
            "start_date": "11/06/2025",
            "end_date": "04/07/2025",
            "initial_capital": "100000",
            "override_leverage": 5000,
            "sb_opt_strategy": {
              "strategy_sets": [
                {
                  "name": "S1",
                  "set_security_type": "option",
                  "market": "nse",
                  "symbol": "NIFTY_SPACE_50",
                  "entry_time": "09:20",
                  "days_to_expire_entry": "0",
                  "exit_time": "15:00",
                  "days_to_expire_exit": "0",
                  "max_allowed_entry_time": "15:00",
                                        "parent_move_to_cost": { "move_to_cost": false },
                    "parent_enter_if_missed": { "entry_if_missed": false },
                  "legs": [
                    {
                      "name": "Leg1",
                      "type": "option",
                      "right": "call",
                      "contract_selection_type": "strike",
                      "contract_selection_value": "0",
                      "direction": "long",
                      "lots": "75",
                      "class_name": "SbExecutor.Executor.SBOptionLeg",
                      "hedge_legs": [],
                                                "isHedge": false,
                      "legEnabled": "optionleg",
                      "contract_selection_strike_stap_size": "0",
                      "entry_execution_settings": {
                        "order_type": "market",
                        "buffer_type": "points",
                        "limit_buffer": 0,
                        "trigger_buffer": 0,
                        "convert_to_market_after": 0,
                        "delay_seconds": 0
                      },
                      "order_product_type": "mis",
                      "reentry_leg_type": false,
                      "is_reentry_leg": false,
                      "exit_execution_settings": {
                        "order_type": "market",
                        "buffer_type": "points",
                        "limit_buffer": 0,
                        "trigger_buffer": 0,
                        "convert_to_market_after": 0,
                        "delay_seconds": 0
                      },
                      "indicator_extras": {
                        "entry_on_underlying": true,
                        "exit_on_underlying": false,
                        "entry_conditions": [],
                        "exit_conditions": []
                      },
                      "expiry_type": "weekly",
                      "expiry_value": "0",
                      "momentum_type": "none",
                      "momentum_value": '0',
                      "target_unit": "none",
                      "target_value": '0',
                      "sl_unit": "none",
                      "sl_value": "",
                      "trailing_sl_type": "none",
                      "trailing_sl_trigger_value": '0',
                      "trailing_sl_value": '0',
                      "trail_sl": false,
                      "rr_type": "reentry",
                      "reentry_type": "none",
                      "reentry_count": "0",
                      "delay_seconds": '0',
                      "lazy_legs": '0',
                      "reentry_reexecution_dependency": "sl",
                      "breakout_bar_starttime": "09:15",
                      "breakout_bar_endtime": "10:00",
                      "breakout_bar_field": "none",
                      "range_breakout": false,
                      "breakout_on_underlying": false,
                      "tg_rr_type": "reentry",
                      "tg_reentry_type": "none",
                      "tg_reentry_count": "0",
                      "tg_delay_seconds": '0',
                      "tg_lazy_legs": '0',
                      "sl_rr_type": "reentry",
                      "sl_reentry_type": "none",
                      "sl_reentry_count": "0",
                      "sl_delay_seconds": '0',
                      "sl_lazy_legs": '0',
                      "minimum_days_to_expiry": "-1",
                      "maximum_days_to_expiry": "-1",
                      "rollover_type": "rollover_reentry",
                      "rollover_days_before_expiry": "0",
                      "rollover_time": "00:00"
                    }
                  ],
                  "holding_type": "mis",
                  "parent_days_to_run": {
                      "days_to_run": [
                        "1",
                        "2",
                        "3",
                        "4",
                        "5"
                      ]
                    },
                                        "parent_is_stbt_btst": { "is_stbt_btst": false },
                    "parent_is_momentum_trade": { "is_momentum_trade": false },
                  "isFutureLegEnabled": "false",
                                        "parent_square_off_all_legs": { "square_off_all_legs": false },
                  "indicator_extras": {
                    "entry_conditions": [],
                    "exit_conditions": []
                  },
                  "external_signal": {
                    "enable": false
                  },
                  "position_type": "intraday",
                  "positional_expire_on": "weekly",
                  "mtm_target_unit": "none",
                  "mtm_target_value": '0',
                  "mtm_sl_unit": "none",
                  "mtm_sl_value": '0',
                  "reexecution_type": "none",
                  "reexecution_count": '0',
                  "reexecution_delay_seconds": '0',
                  "reexecution_dependency": "sl",
                  "combined_momentum_type": "none",
                  "combined_momentum_value": '0',
                  "mtm_lock_target_profit_unit": "none",
                  "mtm_target_profit_reaches": '0',
                  "mtm_lock_target": '0',
                  "is_trail_mtm_lock_profit": 'false',
                  "mtm_trail_lock_profit_unit": "none",
                  "mtm_target_profit_trail_every": "0",
                  "mtm_trail_lock_profit_by": "0",
                  "type": "time_based",
                  "class_name": "SbExecutor.Executor.SBTimeBaseSet"
                }
              ],
              "day_wise_sl": [],
              "day_wise_tg": [],
              "day_wise_tsl": [],
              "lock_profit": [],
              "underlying_from": "spot"
            },
            "type": "option",
            "per_order_fees": 100,
            "slippage": 0.1,
            "brokerage_fees": "zerodha",
            "built_with": "option_builder"
          }
        };    

    const [strategy, setStrategy] = useState<UserBot | null>(null);
    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    const [newBotName, setNewBotName] = useState('');
    const [leftPanelWidth, setLeftPanelWidth] = useState(50); // percentage
    const [isResizing, setIsResizing] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const mutationIsExist = usePostUserBotsIsExist();
    const mutationAdd = useSaveUserBot(() =>{
      // TODO: Implement bot creation logic here
    })
    const breadcrumb = useBreadcrumbManager();
    const theme = useTheme();
    
    // Check if screen is medium or larger
    const isMdAndUp = useMediaQuery(theme.breakpoints.up('lg'));

    const handleMouseDown = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        setIsResizing(true);
    }, []);

    const handleMouseMove = useCallback((e: MouseEvent) => {
        if (!isResizing || !containerRef.current || !isMdAndUp) return;
        
        const containerRect = containerRef.current.getBoundingClientRect();
        const newWidth = ((e.clientX - containerRect.left) / containerRect.width) * 100;
        
        // Limit the width between 20% and 80%
        const clampedWidth = Math.max(20, Math.min(80, newWidth));
        setLeftPanelWidth(clampedWidth);
    }, [isResizing, isMdAndUp]);

    const handleMouseUp = useCallback(() => {
        setIsResizing(false);
    }, []);

    React.useEffect(() => {
        if (isResizing && isMdAndUp) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            
            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [isResizing, handleMouseMove, handleMouseUp, isMdAndUp]);

    const isAiBotsStrategyDownload = useIsFeatureFlag([FEATURES.IS_AI_BOTS_STRATEGY_DOWNLOAD]);
    const isMdUp = useGetMediaQueryUp('md');
    const { data: siteInfo } = useGetSiteInfo();
    const [open, setOpen] = useState(false);

    return (
        <>
            <Helmet>
                <title>AI Bots </title>
                <meta name="description" content="AI Bots" />
            </Helmet>
            <Box className="sticky-top" sx={{
                backgroundColor: theme.palette.common.white,
                transition: theme.transitions.create(['transform', 'opacity'], {
                    duration: theme.transitions.duration.standard,
                }),
            }}>

                <PageHeader
                    variant="market"
                    title={
                        <>
                            AI Bots
                            <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                                Chat with our AI to create trading strategy, and explore strategy details.
                            </Typography>
                        </>
                    }
                    rightElement={
                        <>
                        {isMdUp ? (
                            <>
                            <MuiButton
                                variant="contained"
                                color="secondary"
                                startIcon={<YouTube fontSize="medium" />}
                                onClick={() => setOpen(true)}
                                sx={{ ml: 2 }}
                            >
                                How to ?
                            </MuiButton>
                            </>
                        ) : (
                            <IconButton onClick={() => setOpen(true)} sx={{ p: '3px' }}>
                            <YouTube fontSize="medium" />
                            </IconButton>
                        )}
                        {/* <CustomTooltip tooltipKey={'ai_bots_help'}>
                              {({ isTooltipAvailable }) =>
                                isTooltipAvailable ? (
                                  <IconButton>
                                    <InfoOutlinedIcon />
                                  </IconButton>
                                ) : (
                                  <></>
                                )
                              }
                        </CustomTooltip> */}
                        </>
                    }
                />
                <Divider sx={{ borderBottom: 2, borderColor: 'grey.300' }} />
            </Box>
            <Container 
                ref={containerRef}
                maxWidth="max" 
                sx={{ 
                    py: 0, 
                    px: 0,
                    height: isMdAndUp ? 'calc(100vh - 10px)' : 'auto', // Subtract header height
                    maxHeight: isMdAndUp ? 'calc(100vh - 100px)' : 'none',
                    width: '100%',
                    overflow: isMdAndUp ? 'hidden' : 'visible',
                    cursor: isResizing && isMdAndUp ? 'col-resize' : 'default',
                    '&.MuiContainer-root': {
                        paddingLeft: '0 !important',
                        paddingRight: '0 !important',
                        paddingTop: '0 !important',
                        paddingBottom: '0 !important',
                        margin: '0 !important',
                        maxWidth: '100% !important',
                    },
                    '&.css-17dmow3-MuiContainer-root': {
                        paddingLeft: '0 !important',
                        paddingRight: '0 !important',
                        paddingTop: '0 !important',
                        paddingBottom: '0 !important',
                    }
                }}
            >
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: isMdAndUp ? 'row' : 'column',
                    height: isMdAndUp ? '100%' : 'auto',
                    width: '100%'
                }}>
                    {/* Chat Section */}
                    <Box sx={{ 
                        width: isMdAndUp ? `${leftPanelWidth}%` : '100%',
                        height: isMdAndUp ? '100%' : 'calc(100vh - 100px)',
                        position: 'relative'
                    }}>
                        <Paper sx={{ 
                            height: '100%', 
                            borderRadius: 0,
                            boxShadow: isMdAndUp ? '8px 0 16px -4px rgba(0,0,0,0.10)' : 'none',
                        }}>
                            <AiBotsChat height="100%" setStrategy={setStrategy} setNewBotName={setNewBotName}/>
                        </Paper>
                    </Box>

                    {/* Resize Handle - Only show on medium and up screens */}
                    {isMdAndUp && (
                        <Box
                            sx={{
                                width: '8px',
                                height: '100%',
                                backgroundColor: 'transparent',
                                cursor: 'col-resize',
                                position: 'relative',
                                '&:hover': {
                                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                },
                                '&::after': {
                                    content: '""',
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    width: '2px',
                                    height: '40px',
                                    backgroundColor: 'grey.400',
                                    borderRadius: '1px',
                                }
                            }}
                            onMouseDown={handleMouseDown}
                        />
                    )}

                    {/* Strategy Detail Section */}
                    <Box sx={{ 
                        width: isMdAndUp ? `${100 - leftPanelWidth}%` : '100%',
                        minWidth: isMdAndUp ? '30%' : 'auto',
                        height: '100%'
                    }}>
                        <Paper sx={{ 
                            height: '100%',
                            borderRadius: 0,
                            boxShadow: 'none',
                            border: 'none'
                        }}>
                            <Box sx={{ p: 2, pb: 0.6, borderBottom: 1, borderColor: 'divider' }}>
                                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
                                    <Box>
                                        <Typography variant="h6" gutterBottom>
                                            Strategy Details
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            View and explore trading strategy configurations
                                        </Typography>
                                    </Box>
                                    <Stack direction="row" spacing={1}>
                                        { isAiBotsStrategyDownload && (
                                            <Button
                                            variant="outlined"
                                            size="small"
                                            startIcon={<DownloadIcon />}
                                            onClick={() => {
                                                if (strategy) {
                                                    // Create a blob with the strategy JSON
                                                    const strategyJson = JSON.stringify(strategy, null, 2);
                                                    const blob = new Blob([strategyJson], { type: 'application/json' });
                                                    
                                                    // Create download link
                                                    const url = URL.createObjectURL(blob);
                                                    const link = document.createElement('a');
                                                    link.href = url;
                                                    link.download = `strategy_${strategy.name || 'bot'}_${new Date().toISOString().split('T')[0]}.json`;
                                                    
                                                    // Trigger download
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    
                                                    // Cleanup
                                                    document.body.removeChild(link);
                                                    URL.revokeObjectURL(url);
                                                }
                                            }}
                                            disabled={!strategy || Object.keys(strategy).length === 0}
                                            sx={{
                                                minWidth: 'auto',
                                                px: 2,
                                                py: 0.5,
                                                fontSize: '0.75rem'
                                            }}
                                        >
                                            Download
                                        </Button> 
                                    )}
                                        <Button
                                            variant="contained"
                                            size="small"
                                            startIcon={<AddIcon />}
                                            onClick={() => {
                                                setCreateDialogOpen(true);
                                            }}
                                            disabled={!strategy || Object.keys(strategy).length === 0}
                                            sx={{
                                                minWidth: 'auto',
                                                px: 2,
                                                py: 0.5,
                                                fontSize: '0.75rem'
                                            }}
                                        >
                                            Create
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Box>
                            {strategy && Object.keys(strategy).length > 0 ? (
                                <CustomScrollbar height="calc(100% - 100px)">
                                    <Box sx={{ p: 2 }}>
                                        <StrategyDetailContent
                                            userBotDetails={strategy}
                                            botBuilderType="option"
                                        />
                                    </Box>
                                </CustomScrollbar>
                            ) : (
                                <CustomScrollbar height="calc(100% - 100px)">
                                    <StrategyPlaceholder height="100%" />
                                </CustomScrollbar>
                            )}
                        </Paper>
                    </Box>
                </Box>
            </Container>

            {/* Create Bot Dialog */}
            <Dialog 
                open={createDialogOpen} 
                onClose={() => setCreateDialogOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Create New Bot
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Bot Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={newBotName}
                        onChange={(e) => setNewBotName(e.target.value)}
                        placeholder="Enter a name for your bot"
                        sx={{ mt: 1 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={() => {
                            setCreateDialogOpen(false);
                            setNewBotName('');
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={() => {
                            if (newBotName?.trim()) {
                              mutationIsExist.mutate(
                                { name: newBotName?.trim() },
                                {
                                  onSuccess: resSuccess => {
                                    if (resSuccess.success && strategy)
                                      mutationAdd.mutate(
                                        {...strategy, name: newBotName.trim()},
                                        {
                                          onSuccess: res => {
                                            if (res.success){
                                              breadcrumb.push(
                                                `/bot/${res.bot_id}/strategy/0`,
                                                PAGES.AI_BOTS,
                                                `/ai/bots`,
                                                'AI Bots',
                                              );
                                            }
                                          },
                                        },
                                      );
                                  },
                                },
                              );
                                setCreateDialogOpen(false);
                                setNewBotName('');
                            }
                        }}
                        variant="contained"
                        disabled={!newBotName?.trim()}
                    >
                        Create
                    </Button>
                </DialogActions>
            </Dialog>
            <IframeDialog
                open={open}
                link={
                siteInfo && siteInfo.bot_aibots_help_video_link
                    ? siteInfo.bot_aibots_help_video_link
                    : 'https://www.youtube.com/embed/uV6bmoy-QDk'
                }
                handleClose={() => setOpen(false)}
            />
        </>

    );
};

export default AiBotsPage; 